import tiposFinanciamento from "../constants/tiposFinanciamento";

let styles = {
    body: {
        padding: 10,
        paddingBottom: 65,
        orientation: "landscape",
    },
    table: {
        display: "table",
        width: "auto",
        // borderStyle: "solid",
        // borderColor: '#bfbfbf',
        // borderWidth: 1,
        // borderRightWidth: 0,
        // borderBottomWidth: 1,
        marginTop: 20
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableColHeader: {
        width: "4.8%",
        color: '#fff',
        backgroundColor: '#005caa'
    },
    tableCol: {
        width: "12%",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableColAtuacao: {
        width: "12%",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        backgroundColor: '#86b1d6'
    },
    tableColTotal: {
        width: "4.8%",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        backgroundColor: '#005caa7a'
    },
    tableColHeaderModalidades: {
        width: "13.6%",
        color: '#fff',
        backgroundColor: '#005caa'
    },
    tableColModalidades: {
        width: "30%",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 1,
        borderTopWidth: 0,
        textAlign: "left"
    },
    tableColModalidadesAtuacao: {
        width: "30%",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 1,
        borderTopWidth: 0,
        textAlign: "center",
        backgroundColor: '#005caa7a',
    },
    tableCellHeader: {
        margin: "5px",
        fontSize: 8,
        fontWeight: 500,
        border: "none",
        textAlign: 'center',
    },
    tableCell: {
        margin: "5px auto",
        fontSize: 8
    },
    tableCellModalidades: {
        margin: "5px 2",
        fontSize: 8
    },
    // header
    header: {
        fontSize: 11,
        marginBottom: 15,
        textAlign: 'center',
        color: 'grey',
    },
    titleHeader: {
        fontSize: 14,
        textAlign: 'center',
        fontFamily: 'Oswald'
    },
    title: {
        fontSize: 24,
        textAlign: 'center',
        fontFamily: 'Oswald'
    },
    author: {
        fontSize: 12,
        textAlign: 'center',
        marginBottom: 40,
    },
    image: {
        marginVertical: 15,
        marginHorizontal: 100,
    },
    // page number
    logoContainer: {
        textAlign: 'center'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },
    // unidade
    unidadeHeader: {
        width: "66%",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderBottomColor: '#000',
        borderLeftWidth: 0,
        borderTopWidth: 0,
        color: '#fff',
        backgroundColor: '#005caa',
        textAlign: 'center',
        fontSize: 11,
        margin: "7px auto",
    },
    tableRowUnidadeHeader: {
        margin: "auto",
        flexDirection: "row",
        backgroundColor: '#005caa',
    },
    tableColMetaRealizadoHeader1: {
        width: "19.2%",
        backgroundColor: '#005caa',
    },
    tableColMetaRealizadoHeader2: {
        width: "24%",
        backgroundColor: '#005caa',
    },
    tableCellMetaRealizadoHeader: {
        margin: "5px auto",
        fontSize: 8,
        color: '#fff',
    },
    tableColHeaderMetaRealizadoModalidades: {
        width: "10%",
        backgroundColor: '#005caa'
    },
    tableColCabecalho1: {
        width: "30%",
        backgroundColor: '#005caa',
    },
    tableColCabecalho2: {
        width: "12%",
        backgroundColor: '#005caa',
    },
    resumo: {
        fontSize: 12,
        textAlign: 'left',
        marginBottom: 10,
    },
    tableRowTotais: {
        margin: "auto",
        flexDirection: "row",
        backgroundColor: '#005caa',
        color: '#fff'
    },
    logotipo: {
        width: 200,
        margin: "5px auto",
        marginBottom: 20,
        // textAlign: 'center',
        // justifyContent: 'center',
    },
    space: {
        marginBottom: 40
    },
    resumoRow: {
        textAlign: 'left',
        marginBottom: 5,
        flexDirection: "row"
    },
    resumoChave: {
        fontSize: 12,
        fontWeight: 'extrabold'
    },
    resumoValor: {
        fontSize: 12,
        marginLeft: 7,
        textTransform: 'capitalize'
    },
    textCaptalize: {
        textTransform: 'capitalize'
    }
}

function retiraCodigoUnidade (unidade) {
    if(unidade === 'DR') return 'SENAI/' + unidade
    return unidade.slice(8, unidade.length)
}

function formataMes (props) {
    let { radioChecked, ultimoMesApurado, mesSelecionado } = props;
    if(mesSelecionado === 'marco') mesSelecionado = 'março' 
    if(ultimoMesApurado === 'marco') ultimoMesApurado = 'março' 
    if(radioChecked === 'mes') radioChecked = 'mês' 
    return { radioChecked, ultimoMesApurado, mesSelecionado } 
}

function exibeObservacao (props) {
    let { radioChecked, ultimoMesApurado, mesSelecionado } = formataMes(props);
    let observacao;
    if(radioChecked === 'mês') {
        observacao = `Relatório mensal de ${mesSelecionado}. Tipo: ${radioChecked}`
    }
    else if (radioChecked === 'acumulado') {
        observacao = `Relatório acumulado até ${mesSelecionado}. Tipo: ${radioChecked}`
    }
    return observacao
}

function verificaUltimoMesApuradoAcumulado(ultimoMesApurado, mesSelecionado) {
    let meses = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
    let mes;
    if(meses.indexOf(ultimoMesApurado) > meses.indexOf(mesSelecionado)) mes = mesSelecionado
    else mes = ultimoMesApurado
    return mes;
}

function exibeMes (props, isRealizado=false) {
    let { radioChecked, ultimoMesApurado, mesSelecionado } = formataMes(props);

    let ultimo = verificaUltimoMesApuradoAcumulado(ultimoMesApurado, mesSelecionado);

    let observacao;
    if(radioChecked === 'mês') {
        observacao = mesSelecionado
    }
    else if (radioChecked === 'acumulado') {
        if(isRealizado) mesSelecionado = ultimo
        observacao = `até ${mesSelecionado}`
    }
    return observacao
}

function formataRealizadoMetas (realizados, metas) {
    realizados = JSON.parse(JSON.stringify(realizados))
    metas = JSON.parse(JSON.stringify(metas))
    if(realizados.length === 0) {
        let novo = metas.map((meta) => {
            let modalidade = [...new Set([...Object.keys(meta.modalidades)])]
            let isVazio = tiposFinanciamento.zeroIndicadores()
            let novasModalidades = {}
            modalidade.map(modal => {
                novasModalidades[modal] = {
                    meta: meta.modalidades[modal] === undefined ? isVazio : meta.modalidades[modal],
                    realizado: isVazio
                }
            })
            meta.modalidades = novasModalidades;
            return meta;
        })
    }
    else {

        let novo = realizados.map((realizado) => {
            let unidadeFiltro = metas.filter(meta => meta.unidade === realizado.unidade)[0];
            let modalidade = [...new Set([...Object.keys(realizado.modalidades), ...Object.keys(unidadeFiltro.modalidades)])]
            let isVazio = tiposFinanciamento.zeroIndicadores()
            let novasModalidades = {}
            modalidade.map(modal => {
                novasModalidades[modal] = {
                    meta: unidadeFiltro.modalidades[modal] === undefined ? isVazio : unidadeFiltro.modalidades[modal],
                    realizado: realizado.modalidades[modal] === undefined ? isVazio : realizado.modalidades[modal]
                }
            })
            realizado.modalidades = novasModalidades;
            return realizado;
        })
    }
    if(realizados.length === 0) realizados = JSON.parse(JSON.stringify(metas))
    return realizados;
}

function calculaTotal (realizados) {
    if(!realizados) return
    let totaisObj = {}
    realizados.map((unidade) => {
        let modalidades = unidade.modalidades;
        let obj = {
            meta: tiposFinanciamento.zeroIndicadores(),
            realizado: tiposFinanciamento.zeroIndicadores()
        }
        Object.keys(modalidades).map(modalidade => {
            Object.keys(modalidades[modalidade]['meta']).map(financiamento => obj['meta'][financiamento] += modalidades[modalidade]['meta'][financiamento])
            Object.keys(modalidades[modalidade]['realizado']).map(financiamento => obj['realizado'][financiamento] += modalidades[modalidade]['realizado'][financiamento])
        })
        totaisObj[unidade.unidade] = {
            meta: obj.meta,
            realizado: obj.realizado
        }
    })
    return totaisObj;
}

export default {
    formataMes,
    exibeMes,
    exibeObservacao,
    retiraCodigoUnidade,
    formataRealizadoMetas,
    calculaTotal,
    styles
}